import React from "react";
import { Link } from "react-router-dom";
import { EVENT, ASSETS } from "../mock";

const Footer = () => {
  return (
    <footer className="border-t border-[#161f36] bg-[#070b16]" data-testid="footer">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid md:grid-cols-3 gap-10">
          <div>
            <div className="mb-4">
              <img src={ASSETS.logo} alt="Great Western Funding" className="h-12 w-auto rounded-md" data-testid="footer-logo" />
            </div>
            <p className="text-xs text-[#7f8db0] leading-relaxed">
              {EVENT.company} · {EVENT.companyNmls}
              <br />Oscar Tobar · {EVENT.nmls}
              <br />{EVENT.address}
              <br />Licensed in California & Florida
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#5c6a8c] mb-4">Contact</p>
            <p className="text-xs text-[#aeb9d4] leading-loose">
              <a href="tel:+18182310061" className="hover:text-white transition-colors">{EVENT.phone}</a>
              <br />
              <a href={`mailto:${EVENT.email}`} className="hover:text-white transition-colors">{EVENT.email}</a>
              <br />
              <a href="https://www.greatwesternfunding.com" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors" data-testid="footer-website">{EVENT.website}</a>
            </p>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#5c6a8c] mb-4">Legal</p>
            <div className="flex flex-col gap-2 text-xs text-[#aeb9d4]">
              <Link to="/privacy-policy" className="hover:text-white transition-colors" data-testid="footer-privacy">Privacy Policy</Link>
              <Link to="/terms-conditions" className="hover:text-white transition-colors" data-testid="footer-terms">Terms & Conditions</Link>
            </div>
          </div>
        </div>
        <div className="mt-10 pt-6 border-t border-[#161f36]">
          <div className="flex flex-col sm:flex-row items-start gap-6">
            <img
              src="https://customer-assets-lqy194kg.emergentagent.net/job_funding-webinar/artifacts/8f9dmadm_equal-housing-lender%20logo.png"
              alt="Equal Housing Lender"
              className="h-14 w-auto shrink-0 invert opacity-70"
              data-testid="footer-ehl-logo"
            />
            <p className="text-[10px] text-[#5c6a8c] leading-relaxed">
              This is an educational event, not a loan application or a commitment to lend. Attending does not require a hard
              credit pull and carries no obligation. Great Western Funding is not affiliated with, or endorsed by, the U.S.
              Department of Veterans Affairs or any government agency. All loan approvals are subject to underwriting,
              eligibility, and program guidelines. Equal Housing Lender.
            </p>
          </div>
          <p className="text-[10px] text-[#3f4c6b] mt-4">
            © {new Date().getFullYear()} {EVENT.company}. All rights reserved. · {EVENT.companyNmls} · Oscar Tobar {EVENT.nmls}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
